import { ICompany } from 'app/shared/model/company.model';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';

export interface IRepresentativeTruckImplement {
  id?: number;
  company?: ICompany | null;
  truckImplement?: ITruckImplement | null;
}

export const defaultValue: Readonly<IRepresentativeTruckImplement> = {};
